
export const dataGridFocusStyles = {
  ['& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within']: {
    outline: 'none',
  },
  ['& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within']: {
    outline: 'none',
  },
}
export const dataGridFontSizeStyles = {
  '& .MuiDataGrid-row': {
    fontSize: '0.75rem',
  },
}
